/**
 * Общие утилиты для работы с языками
 */

// Список поддерживаемых языков
export const supportedLangs = ['ru', 'sr', 'en'];
export const defaultLang = 'en';

/**
 * Получение предпочтительного языка пользователя
 */
export const getUserLang = (): string => {
  // Проверяем сохраненный выбор в localStorage
  const savedLang = localStorage.getItem('palkinLang');
  if (savedLang && supportedLangs.includes(savedLang)) {
    return savedLang;
  }

  // Получаем язык браузера
  const browserLang = navigator.language.split('-')[0];
  return supportedLangs.includes(browserLang) ? browserLang : defaultLang;
};

/**
 * Определение текущего языка из URL
 */
export const getCurrentLangFromUrl = (): string => {
  const path = window.location.pathname;
  const pathSegments = path.split('/').filter(Boolean);

  // Если первый сегмент пути - это поддерживаемый язык
  if (pathSegments.length > 0 && supportedLangs.includes(pathSegments[0])) {
    return pathSegments[0];
  }

  // Если язык не указан в URL, считаем что это английский (корневой путь)
  return 'en';
};

/**
 * Переключение на новый язык
 */
export const switchLanguage = (lang: string): void => {
  if (!supportedLangs.includes(lang)) return;
  localStorage.setItem('palkinLang', lang);

  // Строим новый URL для редиректа
  const currentPath = window.location.pathname;
  const currentLang = getCurrentLangFromUrl();

  // Компактная версия формирования URL с учетом en в корне
  let newPath = currentPath
    // Удаляем текущий языковой сегмент
    .replace(new RegExp(`^/${currentLang}/`), '/');

  // Добавляем языковой сегмент только если не английский
  if (lang !== 'en') {
    newPath = `/${lang}${newPath}`;
  }

  window.location.href = newPath + window.location.search + window.location.hash;
};
